module.exports = __webpack_public_path__ + "static/pay-by-bank-list-680efb305462edd0f0ba162549248653.png";